import { SelectedMode } from "app/pages/sales-intelligence/common-components/MultiSelector/types";

export const NO_DATA = "N/A";
export const NO_DATA_HYPHEN = "—";

export const EMPTY_ARRAY = [];

export const START_REGION_ID = 1000;

export const MAX_WIDTH_QUOTA_TOOLTIP = 271;
export const MAX_WIDTH_QUOTA_TOOLTIP_TRIAL = 180;

export const HEADER_LIST_LOADING_HEIGHT = 37;
export const HEADER_LIST_LOADING_WIDTH = 150;

/**
 * MultiSelector default config of items
 */

export const DEFAULT_SELECT_PANEL_ACCOUNT_ITEM = {
    selectedMode: SelectedMode.FROM_LIST,
    selectedItemIndex: 0,
};

export const DEFAULT_SELECT_PANEL_EXCEL_ITEM = {
    selectedMode: SelectedMode.FROM_LIST,
    selectedItemIndex: 0,
};

export const DEFAULT_SELECT_PANEL_ASSIGN_ITEM = {
    selectedMode: SelectedMode.FROM_LIST,
    selectedItemIndex: 0,
};

export const SI_CONTACTS_HOOK_ID = "SI contacts";
export const SI_COUNTRIES_HOOK_ID = "CountryFilter";

export const ABORT_ERROR_NAME = "AbortError";

export const GRID_UPGRADE_MOCK_VALUE = "grid.upgrade";

export const EXTENSION_ID = "ejcibmoopiblhpjkjfpdopfdnlaoolfc";
export const EXTENSION_LINK = `https://chrome.google.com/webstore/detail/similarweb-sales-extensio/${EXTENSION_ID}`;

export const AI_AGENT_GMAIL_KB_ARTICLE_LINK =
    "https://support.similarweb.com/hc/en-us/articles/31178705112861-Using-Similarweb-AI-Outreach-Agent";

export const AI_MEETING_AGENT_KB_ARTICLE_LINK =
    "https://support.similarweb.com/hc/en-us/articles/27189629819165-Using-AI-Meeting-Prep-Agent#h_01JTNNP5Q79CKM3VFCKC36CR1J";

export const NT_PURCHASE_PAGE_LINK =
    "https://account.similarweb.com/journey/purchase-global?currency=USD&package=PremiumSalesExtension&period=annually&promo&workspace=sales";

export const Z_INDEX = {
    default: 1,
    panel: 9,
    dropdown: 99,
    modal: 999,
    modalContent: 9999,
};

export const SELECT_ALL_ITEM_ID = "select_all_item_id";
